import React, { useState } from "react";
import { FORM_INITIAL_DATA, FORM_STEP } from "./Constants";
import useLocalStorageState from "../../Hooks/useLocalStorageState";
import CardWrap from "./components/CardWrap";
import "./Page.css";

const PublicOnboadringPage = () => {
  const [stepState, setStepState] = useState(FORM_STEP[0]);

  const [formData, setFormData] = useLocalStorageState(
    "public-onboarding-form-state",
    FORM_INITIAL_DATA
  );
  const [warningMessage, setWarningMessage] = useState("");

  const { Component } = stepState;

  const nextPage = () => {
    setStepState(FORM_STEP[stepState.step + 1]);
  };

  const previousPage = () => {
    setStepState(FORM_STEP[stepState.step - 1]);
  };

  return (
    <div className="public-onboarding__root">
      <CardWrap
        step={stepState.step}
        subtitle={stepState.subtitle}
        progress={stepState.step * 20}
      >
        <Component
          formData={formData}
          stepState={stepState}
          warningMessage={warningMessage}
          resetData={(msg) => {
            setFormData(FORM_INITIAL_DATA);
            setWarningMessage(msg);
            nextPage();
          }}
          previousPage={previousPage}
          nextPage={(newData) => {
            setFormData((x) => ({ ...x, ...newData }));
            nextPage();
          }}
        />
      </CardWrap>
    </div>
  );
};

export default PublicOnboadringPage;
